export default __webpack_public_path__ + "static/media/413.2dbd57b3.jpg";